module.exports = __webpack_public_path__ + "img/reportSuccess.d581af2b.png";